import React from 'react'
import {
	DeleteButton,
	Edit,
	SimpleForm,
	TextInput,
	RadioButtonGroupInput,
	minLength,
	ReferenceInput,
	SelectInput,
	required,
	email,
	BooleanInput,
	FormDataConsumer,
	Toolbar,
	SaveButton,
} from 'react-admin'

import Permission from '../../components/Permission';
import { EmailVerificationWarning, ResendEmailButton } from '../../components/EmailVerificationAlerts';
import { MarkVerifiedButton } from '../../components/MarkVerifiedButton';
import { PERMISSIONS } from '../../constants';
import { formatAttendantLabel } from '../../utils';

const profilesSx = {
	width: 220,
};

const validatePassword = [minLength(6)];
const validateEmail = [required(), email()]

const AttendantUserEditToolbar = () => (
	<Toolbar sx={{ gap: 1 }}>
		<SaveButton />
		<ResendEmailButton size="medium" />
		<Permission permission={PERMISSIONS.ADMIN}>
			<MarkVerifiedButton size="medium" />
		</Permission>
		<Permission permission={PERMISSIONS.MANAGE_ATTENDANT_USER}>
			<DeleteButton mutationMode="pessimistic" redirect="/attendant-employees" confirmTitle="Excluir usuário" sx={{ marginLeft: 'auto' }} />
		</Permission>
	</Toolbar>
);

export default props => {
	const transform = data => {
		delete data.profile;
		return data;
	};
	return (
		<Permission permission={PERMISSIONS.MANAGE_ATTENDANT_USER}>
			<Edit {...props} transform={transform} title="Editar usuário frentista">
				<SimpleForm sx={{ maxWidth: 600 }} toolbar={<AttendantUserEditToolbar />}>
					<EmailVerificationWarning />
					<Permission permission={PERMISSIONS.ADMIN} >
						<ReferenceInput {...props} label="Rede" source="chainId" reference="chains" sort={{ field: 'name', order: 'ASC' }} perPage={null}>
							<SelectInput optionText="name" InputProps={{ autoComplete: 'off' }} />
						</ReferenceInput>
					</Permission>
					<TextInput source="name" label="Nome" validate={[required()]} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
					<TextInput source="login" label="Login" validate={validateEmail} InputProps={{ autoComplete: 'off' }} sx={{ minWidth: 300 }} />
					<TextInput source="password" label="Senha" validate={validatePassword} InputProps={{ autoComplete: 'new-password' }} sx={{ minWidth: 300 }} />
					<FormDataConsumer>
						{({ formData }) => (
							<ReferenceInput
								source="attendantId"
								reference="attendants"
								filter={{ chainId: formData.chainId }}
								//@ts-ignore
								perPage={null}
								style={{ width: 256 }}
							>
								<SelectInput source="name" label="Frentista" optionText={record => formatAttendantLabel(record)} validate={[required()]} />
							</ReferenceInput>
						)}
					</FormDataConsumer>
					<FormDataConsumer>
						{({ formData }) => (
							<ReferenceInput
								sx={profilesSx}
								label="Perfil"
								source="profileId"
								reference="profiles"
								sort={{ field: 'name', order: 'ASC' }}
								perPage={9999}
								filter={{ chainId: formData.chainId }}>
								<RadioButtonGroupInput optionText="name" validate={[required()]} />
							</ReferenceInput>
						)}
					</FormDataConsumer>
					<BooleanInput source="mustChangePassword" label="Forçar usuário a trocar senha no primeiro acesso" />
				</SimpleForm>
			</Edit>
		</Permission>
	)
}
